import { getResponse } from '@satellite/services/serviceUtilities';
import { cachedInflightRequest } from '@nova/core';
/**
 * options: { fields: string[], joins: string[], includeMetaData: boolean }
 */

export default {
  async createLoadTypeGroup(data, options = {}) {
    const response = await axios.post('/loadtype-group', data);
    return getResponse(response, options);
  },

  async updateLoadTypeGroup(loadTypeData, options = {}) {
    const response = await axios.patch(`/loadtype-group/${loadTypeData.id}`, loadTypeData);
    return getResponse(response, options);
  },

  async deleteLoadTypeGroup(loadTypeGroupId, options = {}) {
    const response = await axios.delete(`/loadtype-group/${loadTypeGroupId}`);
    return getResponse(response, options);
  },

  async getLoadTypeGroups(warehouseId, options = {}) {
    const cacheKey = `load-type-groups:${warehouseId}`;
    return cachedInflightRequest(cacheKey, async () => {
      const response = await axios.get('/loadtype-group', {
        params: {
          warehouseId
        }
      });
      return getResponse(response, options);
    });
  }
};
